import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-youtube-player-block',
  templateUrl: './youtube-player-block.component.html',
  styleUrls: ['./youtube-player-block.component.scss'],
})
export class YoutubePlayerBlockComponent implements OnInit {
  @Input() videoId?: string;
  iframeSrc?: SafeResourceUrl;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const url = 'https://www.youtube.com/embed/' + this.videoId;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
